import { toast } from 'react-toastify';
import moment from 'moment';

import {
  fetchOthersScheduling,
  createOthersScheduling,
  updateOthersScheduling,
  deleteOthersScheduling
} from './services';

import {
  setIsLoading,
  setSchedulingOthers
} from './actions';

import { loadCalendarServices } from 'pages/Scheduling/store/thunk';

export const loadOthersScheduling = (userId, establishmentId, id) => dispatch => {
  dispatch(setIsLoading(true));

  return fetchOthersScheduling(userId, establishmentId, id)
    .then(({ data }) => dispatch(setSchedulingOthers(data)))
    .finally(() => dispatch(setIsLoading(false)));
}

export const upsertOthersScheduling = (userId, establishmentId, id, params) => dispatch => {
  dispatch(setIsLoading(true));

  if(!id) {
    return createOthersScheduling(userId, establishmentId, params)
      .then(({ data }) => {
        toast.success('Agendamento cadastrado com sucesso.');
        dispatch(setSchedulingOthers(data));
        return Promise.resolve();
      })
      .catch(() => {
        toast.error('Houve um problema ao cadastrar o agendamento.');
        return Promise.reject();
      })
      .finally(() => dispatch(setIsLoading(false)));
  }

  return updateOthersScheduling(userId, establishmentId, id, params)
    .then(({ data }) => {
      toast.success('Agendamento atualizado com sucesso.');
      dispatch(setSchedulingOthers(data));
      return Promise.resolve();
    })
    .catch(() => {
      toast.error('Houve um problema ao atualizar o agendamento.');
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}

export const removeOthersScheduling = (userId, establishmentId, id) => dispatch => {
  dispatch(setIsLoading(true));

  return deleteOthersScheduling(userId, establishmentId, id)
    .then(() => {
      toast.success('Agendamento removido com sucesso.');

      const extraProps = {
        initialDate: moment().startOf('month').format('YYYY-MM-DD'),
        finalDate: moment().endOf('month').format('YYYY-MM-DD')
      }

      dispatch(loadCalendarServices(userId, establishmentId, extraProps, ''));

      return Promise.resolve();
    })
    .catch(() => {
      toast.error('Houve um problema ao remover o agendamento.');
      return Promise.reject();
    })
    .finally(() => dispatch(setIsLoading(false)));
}